import React from "react";

export default function RiderTermsAndConditions() {
  return (
    <div
      style={{
        backgroundColor: "#F8F9FA",
        padding: "100px 20px",
        fontFamily: "'Inter', sans-serif",
        color: "#1C1C1C",
        lineHeight: "1.8",
      }}
    >
      <h1
        style={{
          fontFamily: "'Poppins', sans-serif",
          fontSize: "3rem",
          background: "linear-gradient(90deg, #E63946, #FFC300)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          marginBottom: "40px",
          textAlign: "center",
        }}
      >
        Terms & Conditions (For Riders / Drivers)
      </h1>

      {/* Section Intro */}
      <div style={sectionBoxStyle}>
        <p>
          🚖 <strong>INRYDE Rider (Driver) Terms & Conditions</strong>
          <br />
          These Terms & Conditions ("Agreement") apply to all individuals registered as
          Rider (Driver) on the INRYDE platform. By registering and using the INRYDE
          application, the Rider agrees to the clauses below.
        </p>
      </div>

      {/* Section 1 */}
      <div style={sectionBoxStyle}>
        <GradientHeading text="1. Relationship Between INRYDE & Rider" />
        <ul style={listStyle}>
          <li>The Rider is an independent service provider, not an employee, partner, or agent of INRYDE.</li>
          <li>No employment benefits apply (salary, PF, leaves, insurance, gratuity, etc. unless separately issued).</li>
          <li>INRYDE only provides a technology platform to connect Riders and Customers.</li>
          <li>INRYDE does not guarantee earnings, ride volume, incentives, or demand.</li>
        </ul>
      </div>

      {/* Section 2 */}
      <div style={sectionBoxStyle}>
        <GradientHeading text="2. Registration & Account Usage" />
        <ul style={listStyle}>
          <li>Rider must submit authentic, valid documents (Driving Licence, RC, Insurance, Permit, Fitness, PUC).</li>
          <li>Fake, expired, or altered documents may lead to termination without notice.</li>
          <li>Rider is fully responsible for securing login credentials; account sharing is prohibited.</li>
          <li>INRYDE may contact Riders via SMS, WhatsApp, email, call, or app notification for operational or safety purposes.</li>
        </ul>
      </div>

      {/* Section 3 */}
      <div style={sectionBoxStyle}>
        <GradientHeading text="3. Eligibility Requirements" />
        <ul style={listStyle}>
          <li>Rider is 18+ years old.</li>
          <li>Has minimum 2 years of driving experience.</li>
          <li>Medically fit and permitted by law to provide rides.</li>
          <li>No criminal background, DUI record, or major pending challans.</li>
          <li>Legally authorized to operate the vehicle on public roads.</li>
        </ul>
      </div>

      {/* Section 4 */}
      <div style={sectionBoxStyle}>
        <GradientHeading text="4. Ride Acceptance, Cancellation & Behaviour" />
        <ul style={listStyle}>
          <li>Rider may accept or reject bookings, but frequent cancellations may lead to penalties or suspension.</li>
          <li>Rider must treat Customers professionally—no harassment, threats, discrimination, or overcharging.</li>
          <li>No unauthorized passengers may accompany the Rider during an active ride.</li>
          <li>GPS must remain active throughout the ride.</li>
        </ul>
      </div>

      {/* Section 5 */}
      <div style={sectionBoxStyle}>
        <GradientHeading text="5. Earnings, Payments & Taxes" />
        <ul style={listStyle}>
          <li>INRYDE may charge commission/service fee/subscription fee plus applicable taxes.</li>
          <li>Rider may receive fare directly from Customer when applicable (e.g., cash payments).</li>
          <li>Rider is responsible for all applicable taxes (GST, Income Tax, etc.).</li>
          <li>
            INRYDE will assist with settlement delays or technical issues, but is not liable for losses caused by third-party
            payment gateways or banks.
          </li>
        </ul>
      </div>

      {/* Section 6 */}
      <div style={sectionBoxStyle}>
        <GradientHeading text="6. Conduct, Safety & Obligations" />
        <ul style={listStyle}>
          <li>Follow traffic rules and safe driving standards.</li>
          <li>No drugs, alcohol, or intoxicants while providing services.</li>
          <li>Vehicle must be clean and well-maintained.</li>
          <li>Respect Customer privacy; no personal contact after the ride.</li>
          <li>Use safe routes; avoid risky shortcuts unless requested by Customer.</li>
        </ul>
      </div>

      {/* Section 7 */}
      <div style={sectionBoxStyle}>
        <GradientHeading text="7. Privacy & Data Usage" />
        <ul style={listStyle}>
          <li>INRYDE may collect Rider’s KYC, location, device, and trip data for safety and compliance.</li>
          <li>Data may be shared with authorities in case of disputes, complaints, or investigations.</li>
          <li>Rider must not misuse Customer’s personal information.</li>
        </ul>
      </div>

      {/* Section 8 */}
      <div style={sectionBoxStyle}>
        <GradientHeading text="8. Insurance & Liability" />
        <ul style={listStyle}>
          <li>INRYDE may provide limited insurance depending on city and scheme.</li>
          <li>Rider is responsible for vehicle damages, challans, penalties, and accident liabilities unless covered by policy.</li>
        </ul>
      </div>

      {/* Section 9 */}
      <div style={sectionBoxStyle}>
        <GradientHeading text="9. Indemnity" />
        <p>
          Rider agrees to compensate INRYDE for losses due to misuse of platform, fake documents, illegal activity,
          negligence, or Customer disputes caused by Rider’s actions.
        </p>
      </div>

      {/* Section 10 */}
      <div style={sectionBoxStyle}>
        <GradientHeading text="10. Suspension & Termination" />
        <p>
          INRYDE may suspend or terminate Rider accounts for fraud, fake documents, misconduct, unsafe driving, repeated
          cancellations, harassment, low ratings, or violation of any Terms or applicable laws. Serious violations may
          result in immediate termination without notice.
        </p>
      </div>

      {/* Section 11 */}
      <div style={sectionBoxStyle}>
        <GradientHeading text="11. Governing Law & Dispute Resolution" />
        <p>
          These Terms are governed by Indian law. Parties must attempt settlement within 15 days. If unresolved,
          disputes proceed to arbitration with a mutually appointed arbitrator. Jurisdiction and seat of arbitration shall
          be the city specified by INRYDE Headquarters. Proceedings shall be conducted in English.
        </p>
      </div>

      {/* Section 12 */}
      <div style={sectionBoxStyle}>
        <GradientHeading text="12. Notices & Policy Updates" />
        <p>
          Updates will be communicated via app notifications, SMS, or email. Continued use of the app implies acceptance of
          revised terms.
        </p>
      </div>

      {/* Final Note */}
      <div style={sectionBoxStyle}>
        <p>
          <strong>
            By registering on INRYDE, the Rider confirms that they have read, understood, and agreed to these Terms &
            Conditions.
          </strong>
        </p>
      </div>
    </div>
  );
}

/* Reusable Styles */
const sectionBoxStyle = {
  backgroundColor: "#FFFFFF",
  padding: "30px",
  borderRadius: "15px",
  boxShadow: "0 4px 15px rgba(0,0,0,0.05)",
  marginBottom: "30px",
};

const listStyle = {
  color: "#6C757D",
  paddingLeft: "20px",
  listStyleType: "disc",
};

/* Gradient Heading Component */
function GradientHeading({ text }) {
  return (
    <h2
      style={{
        fontFamily: "'Poppins', sans-serif",
        background: "linear-gradient(90deg, #E63946, #FFC300)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        fontWeight: "600",
        fontSize: "1.5rem",
        marginBottom: "20px",
      }}
    >
      {text}
    </h2>
  );
}
